// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__n4kO0","alertIcon":"ConfirmModal_alertIcon__3NYm3"};